export const SESSION_TOKEN_KEY = "give-session-token";
export const PKCE_COOKIE_NAME = "okta_pkce";

// Signup callback cookies — set by /api/auth/okta-callback, consumed by
// /signup/callback. Single source of truth for the names + scope.
export const SIGNUP_COOKIE_PATH = "/signup";

export const SIGNUP_COOKIE_NAMES = {
  SESSION: "signup_session",
  PROVIDER: "signup_provider",
  FIRST_NAME: "signup_first_name",
  LAST_NAME: "signup_last_name",
  EMAIL: "signup_email",
} as const;
